import { useEffect } from "react";

/**
 * Ouvre le calendrier natif dès le clic sur n'importe quel champ date/heure
 * de l'application (au lieu de devoir viser la petite icône, ou saisir la
 * date à la main). Un seul écouteur global : couvre l'admin, l'agent et tout
 * nouveau champ ajouté plus tard.
 */
const PICKER_TYPES = new Set(["date", "datetime-local", "month", "time", "week"]);

export function useNativeDatePicker() {
  useEffect(() => {
    const open = (e) => {
      const el = e.target;
      if (el?.tagName !== "INPUT" || !PICKER_TYPES.has(el.type)) return;
      if (el.readOnly || el.disabled) return;
      try { el.showPicker?.(); } catch { /* non supporté : saisie manuelle */ }
    };
    // Capture phase : certains conteneurs (modals shadcn/Radix) stoppent la
    // propagation en bubbling ; on capture donc l'évènement au vol.
    document.addEventListener("click", open, true);
    return () => document.removeEventListener("click", open, true);
  }, []);
}

export default useNativeDatePicker;
